import { FeatureFlagKey } from "@repo/app-types/featureFlags/keys";
import { useIsFeatureFlagEnabled } from "./featureFlags/hooks.js";

export function useMainNavigationFeatureFlags() {
  // Recruiting is on for everyone but an exclusion list, so it is gated on the
  // inverted flag rather than an opt-in one.
  const hasRecruiting = !useIsFeatureFlagEnabled(FeatureFlagKey.HideHireTab);

  const hasTraining = useIsFeatureFlagEnabled(FeatureFlagKey.Training);
  const hasTeamPerformanceTab = useIsFeatureFlagEnabled(
    FeatureFlagKey.TeamPerformanceTab,
  );

  const hasAgentsTab = useIsFeatureFlagEnabled(FeatureFlagKey.AgentsTab);

  return {
    hasRecruiting,
    hasTraining,
    hasTeamPerformanceTab,
    hasAgentsTab,
  };
}
